import React from "react"
import StyledImage from "./styled-image"
import RollingHills from "./icons/rolling-hills"
import Carousel from "./carousel"
import Cta from "./cta"
import { Disclosure } from '@headlessui/react'
import { kebabCase } from "lodash"

export default function Content({ props, index, mobileIndex }) {
  const {
    heading,
    content,
    cta,
    alignment,
    contentWidth,
    backgroundColor,
    blocksFormat,
    collapseContentOnMobile,
    collapseBlocksContentOnMobile,
    collapseBlocksContent,
    sliderOverrides
  } = props
  const blocks = props.isPromotions ?
    props.blocks?.filter(block => block.display === true)
    : props.blocks
  const mini = blocksFormat === "stackMini"
  const collapse = collapseBlocksContentOnMobile ? "mobile" : collapseBlocksContent ? "all" : null
  const carousel = (blocksFormat === "sliderLight" || blocksFormat === "sliderDark") && blocks?.length > 2
  const variable = blocksFormat === "variable"
  const stack = blocksFormat === "stack" || blocksFormat === "stackWide" || blocksFormat === "stackThin" || blocksFormat === "stackMini" || ((blocksFormat === "sliderLight" || blocksFormat === "sliderDark") && !blocks?.length > 2)
  const carouselSettingsOverrides = sliderOverrides ? sliderOverrides : {
    slidesToShow: 3,
    slidesToScroll: 3,
    className: `slick-arrows-centered slick-arrows-wide -mx-[1px] ${blocksFormat === "sliderDark" ? "slick-arrows-light" : ""}`,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  const contentExcerpt = content?.split(' ')?.length > 32 ? content?.split(' ')?.slice(0, 22)?.join(' ') + " …" : null
  const darkMode = backgroundColor === "green" || blocksFormat === "sliderDark"
  const coloredBackground = darkMode || backgroundColor === "gold"
  const usePadding = contentWidth !== "fluid" && (blocksFormat === "sliderDark" || backgroundColor === "green" || backgroundColor === "gold" || (mobileIndex % 2 === 0 || (!heading && !content))) ? true : false
  return (
    <section
      id={heading ? kebabCase(heading) : index ? `section-${index}` : null}
      className={`print:bg-transparent relative
      ${variable ? "md:overflow-x-clip md:w-screen" : mini ? "py-8 md:py-0" : "md:mb-16"} 
      ${blocksFormat === "sliderDark" ? "bg-banner-gradient" : backgroundColor === "green" ? "bg-green" : backgroundColor === "gold" ? "bg-gold" : (mobileIndex % 2 === 0 || (!heading && !content)) ? "bg-white" : `bg-banner-gradient/10 md:bg-none md:bg-white ${contentWidth === "fluid" ? "" : mini ? "" : `${heading || content ? "pt-8 md:pt-0 md:mt-12" : ""} 
      ${carousel || !blocks ? "mb-12" : ""}`}`}`}
    >
      {blocksFormat === "sliderDark" ? <RollingHills /> : null}
      <div className={`${usePadding ? `${heading || content ? "pt-8 md:pt-12" : ""} ${variable ? "" : "md:pb-16"} ${carousel || !blocks ? "pb-12" : ""}` : ""}`}>
        <div className={`${contentWidth === "fluid" ? "" : "container"}`}>

          <div
            className={`${contentWidth === "full" || contentWidth === "fluid" ? "" : "max-w-5xl"} ${alignment === "center" ? "md:text-center mx-auto" : "md:text-left"} ${darkMode ? "text-white links-light" : ""}`}
          >
            {heading && (
              <>

                {index === 0 ?
                  <h1 id={kebabCase(heading)} className={`${darkMode ? "text-white" : ""}`}>{heading}</h1>
                  :
                  <h2 id={kebabCase(heading)} className={`${darkMode ? "text-white" : sliderOverrides?.slidesToScroll === 1 ? "h3-lg" : ""}`}>{heading}</h2>}
              </>
            )}
            {content && (
              <div className={`parsed-content ${heading ? "pt-2" : ""}`}>
                {collapseContentOnMobile && contentExcerpt ?
                  <div className="md:hidden">
                    <Disclosure>
                      {({ open }) => (
                        <>
                          {!open && <div
                            className={``}
                            dangerouslySetInnerHTML={{
                              __html: contentExcerpt,
                            }}
                          />}

                          <Disclosure.Panel><div
                            className={``}
                            dangerouslySetInnerHTML={{
                              __html: content,
                            }}
                          /></Disclosure.Panel>
                          <Disclosure.Button className="btn-text">
                            {open ? "Read Less" : "Read More"}
                          </Disclosure.Button>
                        </>
                      )}
                    </Disclosure>
                  </div>
                  : <div
                    className={`md:hidden`}
                    dangerouslySetInnerHTML={{
                      __html: content,
                    }}
                  />}
                <div
                  className={`hidden md:block`}
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
              </div>
            )}
          </div>
        </div>
        {blocks ?
          <div className={`${carousel ? "container" : ""} px-8 mx-auto md:container`}>
            <div className="pt-5 md:pt-8">
              {carousel ?
                <Carousel settingsOverrides={carouselSettingsOverrides}>
                  {blocks?.map((block, index) => {
                    return (
                      <Block index={index} props={block} key={index} isCarousel={true} collapse={collapse} />
                    )
                  }
                  )}
                </Carousel>
                :
                <ul className={`grid md:grid-cols-2 ${mini ? "xl:gap-8" : "md:gap-8"} justify-items-stretch md:justify-items-start md:justify-center items-stretch ${mini ? "" : "-mx-8"} md:mx-0 
                ${blocksFormat === 'variable' ? "md:gap-y-0 lg:gap-x-12 xl:gap-x-20 2xl:gap-x-24 md:-mt-8 xl:-mt-12"
                    : blocksFormat === "stackWide" ? "lg:gap-12 xl:gap-x-20 xl:gap-y-16 2xl:gap-x-28"
                      : mini ? `grid-cols-2 lg:grid-cols-5 rounded-xl bg-transparent md:p-4 lg:px-6 ${index % 2 === 0 ? "md:bg-light-gray/50" : "md:bg-light-gray"}`
                        : blocksFormat === "stackThin" ? "lg:grid-cols-4"
                          : stack ? "lg:grid-cols-3"
                            : ""}`}>
                  {blocks?.map((block, index) => {
                    return (
                      <li className={`${mini ? "" : "p-8"} w-full md:mx-auto md:p-0 last-of-type:pb-12 last-of-type:md:pb-0 md:bg-none md:bg-transparent
                      ${(variable && index % 6 === 5) ? "bg-purple" : (variable && index % 6 === 2) ? "bg-green" : coloredBackground ? "bg-transparent" : mini ? "bg-transparent" : (index % 2 === 1) ? "bg-white" : "bg-banner-gradient/10"}
                  ${stack ? ""
                          : variable ? `${index % 3 === 2 ? "md:col-span-2 md:w-full" : ""}` : ""}
                      `}
                        key={index}>
                        <Block index={index} props={block} variable={variable} collapse={collapse} blocksFormat={blocksFormat} mini={mini} />
                      </li>
                    )
                  }
                  )}
                </ul>}
            </div>
          </div>
          : null}
        {cta && (
          <div className={`flex items-center ${!blocks && alignment === "center" ? "md:justify-center" : !blocks && alignment === "left" ? "" : "justify-center"} py-6 md:py-8 container ${darkMode ? "links-light" : ""}`}>
            <Cta props={cta} arrow={true} />
          </div>
        )}

      </div>

    </section >
  )
}
export function Block({ props, isCarousel, variable, blocksFormat, index, collapse, children, mini }) {
  const { heading, content, cta, image, icon, subheading, secondaryCta, ctaFormat } = props
  const download = image?.localFile?.extension === "pdf" && image.localFile.publicURL ? { url: image.localFile.publicURL, target: "_blank", title: "Open PDF" } : null
  const parsedContent = collapse ? content?.replace(/<[^>]*>/g, "") : null
  const excerpt = (collapse && parsedContent?.length > 12) ? parsedContent.split(" ").slice(0, 10).join(" ") : null
  return (
    <div id={heading ? kebabCase(heading) : `content-block-${index}`} className={`relative flex flex-col h-full w-full ${blocksFormat === "stackWide" ? "max-w-[32rem]" : "max-w-[24rem]"} ${isCarousel ? "mx-auto px-4" : "mx-auto md:mx-0"}
      ${variable ? `md:max-w-full md:py-12 xl:py-16 ${index % 3 === 2 ? "md:grid md:grid-cols-2 md:items-center" : ""}`
        : blocksFormat === "stackWide" ? "md:max-w-full"
          : "md:max-w-[26rem]"}`}>
      {(variable && index % 3 === 2) ? <div className={`hidden md:block absolute inset-y-0 -inset-x-full md:bg-banner-gradient/10`}></div> : null}
      {image ? (
        <div
          className={`print:max-w-sm flex justify-center relative block-img w-full aspect-video
          `}
        //     ${variable ? `h-40 md:h-56 lg:h-72 ${index % 3 === 2 ? "xl:h-[22rem] 2xl:h-[26rem]" : "xl:h-80 2xl:h-96"}`
        //         : blocksFormat === "stackWide" ? "h-52 sm:h-72 md:h-52 lg:h-72 xl:h-[22rem] 2xl:h-[26rem]"
        // : "h-40 xl:h-44" }
        >
          {cta?.url ?
            <Cta props={{ url: cta.url, target: cta.target }} className="block" canStretch>
              <StyledImage
                image={image}
                objectFit="cover"
                className={`w-full aspect-video`} />
            </Cta>
            : <StyledImage
              image={image}
              objectFit="cover"
              className={`w-full aspect-video`} />}
        </div>
      ) : null}
      {heading || subheading || content || cta || icon ?
        <div className={`flex-grow self-stretch ${variable ? `xl:mx-8 ${index % 3 === 2 ? "md:bg-transparent md:shadow-none md:mt-0 xl:px-4" : "2xl:mx-12 xl:-mt-6 xl:px-6"}` : mini ? "" : "xl:mx-6 xl:px-5"} ${mini ? "" : "bg-white sm:shadow-spread-sm shadow-spread-xs"} ${image ? "-mt-4" : ""} ${icon ? `${mini ? "" : "p-5  sm:mx-4"} my-4 text-center` : "py-4 px-5 lg:px-4 sm:mx-4"} mx-2 relative rounded flex-grow`}>
          {icon ? (
            <div
              className={`${icon?.localFile?.extension === "svg" ? "h-16 w-16" : "h-20 w-auto"} mx-auto mb-2`}
            >
              <StyledImage
                image={icon}
                objectFit="contain"
                className={`w-full h-full`} />
            </div>
          ) : null}
          <div className="mb-2">
            {heading ? <h3 className={`${variable ? index % 3 === 2 ? "md:h1" : "md:h3-lg" : blocksFormat === "stackWide" ? "md:h3-lg" : ""}`}>{heading}</h3> : null}
            {subheading ? <h4 className={`mt-1 leading-snug ${variable ? `text-wire ${index % 3 === 2 ? "md:text-lg md:text-purple-900" : ""}` : ""}`}>{subheading}</h4> : null}
          </div>
          {content && (
            <div className="mt-1 text-sm sm:text-base parsed-content">
              {(collapse && excerpt) ?
                <div className={collapse === "mobile" ? "md:hidden" : ""}>
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Panel><div
                          className={``}
                          dangerouslySetInnerHTML={{
                            __html: content,
                          }}
                        /></Disclosure.Panel>
                        <Disclosure.Button>
                          <div className="text-left">
                            <div
                              className={`${open ? "hidden" : ""}`}
                              dangerouslySetInnerHTML={{
                                __html: excerpt + " …",
                              }}
                            />
                            <div className="btn-text text-base">
                              {open ? "Read Less" : "Read More"}
                            </div>
                          </div>
                        </Disclosure.Button>
                      </>
                    )}
                  </Disclosure>
                </div>
                : <div
                  className={"md:hidden"}
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />}
              <div
                className={`hidden ${collapse === "mobile" ? "md:block" : collapse === "all" ? "" : "md:block"}`}
                dangerouslySetInnerHTML={{
                  __html: content,
                }}
              />
            </div>
          )}
          {children ? <div className="mt-1 text-sm sm:text-base parsed-content">{children}</div> : null}
          {(cta || download) && (
            <div className={`mt-1 flex flex-wrap items-center ${icon ? "justify-center" : ""} ${blocksFormat === "stackWide" || ctaFormat === "button" ? "gap-x-4" : "gap-x-2"}`}>
              {cta ? <Cta props={cta} canStretch={!download} className={`${blocksFormat === "stackWide" || ctaFormat === "button" ? "btn-sm btn-green mt-4" : ""}`} /> : null}
              {secondaryCta ? <>{blocksFormat !== "stackWide" && ctaFormat !== "button" ? <span className="inline-block mx-2 text-green-50">|</span> : null}<Cta props={secondaryCta} canStretch={false} className={`${blocksFormat === "stackWide" || ctaFormat === "button" ? "btn-sm btn-green mt-4" : ""}`} /></> : null}
              {download ? <>{cta && blocksFormat !== "stackWide" && ctaFormat !== "button" ? <><span className="inline-block mx-2 text-green-50">|</span></> : null}<Cta props={download} canStretch={!cta && !secondaryCta} className={`${blocksFormat === "stackWide" || ctaFormat === "button" ? "btn-sm btn-green mt-4" : ""}`} /></> : null}
            </div>
          )}
        </div> : null}
    </div>
  )
}

